/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */
var core_1 = require("@angular/core");
/**
 * @stable
 */
exports.VERSION = new core_1.Version('4.1.3');
//# sourceMappingURL=version.js.map